import { render, staticRenderFns } from "./Humanities.vue?vue&type=template&id=3bd8e828&scoped=true&"
import script from "./Humanities.vue?vue&type=script&lang=js&"
export * from "./Humanities.vue?vue&type=script&lang=js&"
import style0 from "./Humanities.vue?vue&type=style&index=0&id=3bd8e828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8e828",
  null
  
)

export default component.exports